import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {SubscribeState, getInitialState} from '@web/slices/subscribe/slice'

import {MakeCreateSliceOptions, SubscribeReducers} from './interfaces'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<SubscribeState, SubscribeReducers, 'subscribe', SliceSelectors<SubscribeState>>({
        name: 'subscribe',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
        },
    })
